import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import { nextTick } from 'vue';

const routes = [
    // 홈
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            title: '스타필드 마켓',
        },
    },
    // 소개
    {
        path: '/about',
        name: 'about',
        component: () => import('@/views/AboutView.vue'),
        meta: {
            title: '스타필드 마켓소개',
        },
    },
    // 매장목록
    {
        path: '/store',
        name: 'store',
        component: () => import('@/views/StoreView.vue'),
        meta: {
            title: '매장안내',
        },
    },
    // 매장화면 특정탭으로 이동(레스토랑&카페, 편의시설)
    {
        path: '/store/:toWhichTab',
        name: 'toStoreTab',
        component: () => import('@/views/StoreView.vue'),
        meta: {
            title: '매장안내',
        },
    },
    // 공지상세
    {
        path: '/notice/detail/:noticeId',
        name: 'toNoticeDetail',
        component: () => import('@/views/notice/NoticeDetailView.vue'),
        meta: {
            title: '공지사항',
        },
    },
    // 이벤트상세
    {
        path: '/event/detail/:eventId',
        name: 'toEventDetail',
        component: () => import('@/views/event/EventDetailView.vue'),
        meta: {
            title: '이벤트',
            showShare: true,
        },
    },
    // 매장상세
    {
        path: '/store/detail/:storeId',
        name: 'toStoreDetail',
        component: () => import('@/views/store/StoreDetailView.vue'),
    },
    // 웹페이지상세
    {
        path: '/web/detail',
        name: 'toWebDetail',
        component: () => import('@/views/web/WebDetailView.vue'),
        meta: {
            title: '스타필드 마켓',
        },
    },
    // 맵
    {
        path: '/map',
        name: 'map',
        component: () => import('@/views/MapView.vue'),
        meta: {
            title: '지도보기',
        },
    },
    {
        path: '/map2',
        name: 'toMap',
        component: () => import('@/views/MapView2.vue'),
        meta: {
            title: '지도보기',
        },
    },
    // 팝업인경우
    {
        path: '/popup',
        component: () => import('@/components/layout/LayoutPopup.vue'),
        children: [
            // 소개
            {
                path: '/winAbout',
                component: () => import('@/views/AboutView.vue'),
            },
            // 맵
            {
                path: '/winMap',
                component: () => import('@/views/MapView.vue'),
            },
            // 공지상세
            {
                path: '/winNotice',
                component: () => import('@/views/notice/NoticeDetailView.vue'),
            },
            // 이벤트상세
            {
                path: '/winEvent',
                component: () => import('@/views/event/EventDetailView.vue'),
            },
            // 매장상세
            {
                path: '/winStore',
                component: () => import('@/views/store/StoreDetailView.vue'),
            },
            // 웹페이지상세
            {
                path: '/winWeb',
                component: () => import('@/views/web/WebDetailView.vue'),
            },
        ],
    },
    // 페이지를 찾지 못하는 경우
    {
        path: '/:catchAll(.*)',
        component: () => import('@/components/common/NotFound.vue'),
    },
    {
        path: '/home',
        redirect: '/',
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const makeTitle = (title) => (title ? `${title}` : document.title);

router.afterEach((to) => {
    nextTick(() => {
        document.title = makeTitle(to.meta.title);
    });
    //매장안내 선택  햄버거메뉴 선택시 컨택트 정보 초기화
    const fromName = localStorage.getItem('fromName');
    if (fromName !== 'toStoreDetail' && to.name !== 'toStoreDetail') {
        localStorage.setItem('fIndex', '-1');
        localStorage.setItem('cIndex', '-2');
        localStorage.setItem('categoryId', '');
    }
    localStorage.setItem('fromName', to.name);
});
export default router;
